import { attente_icon, devis_icon, rdv_icon } from '../utils/images';

export const pathObject = {
	quotes: 'Mes devis proposés',
	'waiting-acceptation': "En attente d'acceptation",
	'waiting-acceptations': "En attente d'acceptation",
	'accepted-quotes': 'Rendez-vous accepté',
	'accepted-rdv': 'Rendez-vous accepté',
	reviews: 'Donner votre avis',
	'share-documents': 'Partager des documents',
	'payment-quote': 'Commissions à payer',
	'client-history': 'Historique clients',
	procedure: 'Suivre ma procédure',
	settings: 'Mes paramètres',
};

export const procedureImgs = {
	'-1': {
		src: devis_icon,
		alt: 'fiche de devis',
	},
	0: {
		src: attente_icon,
		alt: 'sablier',
	},
	1: {
		src: attente_icon,
		alt: 'sablier',
	},
	2: {
		src: rdv_icon,
		alt: 'calendrier',
	},
	3: {
		src: rdv_icon,
		alt: 'calendrier',
	},
	4: {
		src: rdv_icon,
		alt: 'calendrier',
	},
};
